import styled from "styled-components";

export const Container = styled.div`
	padding: 0 1rem;
`;

export const Title = styled.h2`
	margin: 1rem;
`;
